import React from "react";

function FaqPanel(props) {
	console.log(props);
	return <div>{props.children}</div>;
}

export default FaqPanel;
